import { FC } from 'react';
import { BrandPageProps } from './types';
import { Wrapper } from './styled';

const BrandPage: FC<BrandPageProps> = ({ children, className }) => <Wrapper className={className}>{children}</Wrapper>;

export default BrandPage;
